import API_CONFIG from '../config/api';

// Generic API request function
const apiRequest = async (endpoint, options = {}) => {
  const url = `${API_CONFIG.baseURL}${endpoint}`;
  
  const defaultOptions = {
    mode: 'cors',
    credentials: 'omit',
    headers: {
      ...API_CONFIG.headers,
      ...options.headers,
    },
    timeout: API_CONFIG.timeout,
  };

  const config = {
    ...defaultOptions,
    ...options,
  };

  try {
    const response = await fetch(url, config);
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status} - ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error(`API request failed for ${endpoint}:`, error);
    throw error;
  }
};

// Authentication API
export const authAPI = {
  validateEmployee: async (employeeId, enteredPin) => {
    return await apiRequest(`/auth/${employeeId}/validateEmployee`, {
      method: 'POST',
      body: JSON.stringify({ enteredPin }),
    });
  },
  
  adminLogin: async (username, password) => {
    return await apiRequest('/auth/admin/login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    });
  },
};

// Employee API
export const employeeAPI = {
  getAll: async () => {
    return await apiRequest('/employees');
  },
  
  getDetails: async (employeeId, page = 2, limit = 5) => {
    return await apiRequest(`/employees/${employeeId}/getEmployeeDetails?page=${page}&limit=${limit}`);
  },
  
  getLatestClocking: async (employeeId) => {
    return await apiRequest(`/employees/${employeeId}/latest-clocking`);
  },
  
  clockIn: async (employeeId) => {
    return await apiRequest(`/employees/${employeeId}/clock-in`, {
      method: 'POST',
    });
  },
  
  clockOut: async (employeeId) => {
    return await apiRequest(`/employees/${employeeId}/clock-out`, {
      method: 'POST',
    });
  },
};

// Shift Activities API
export const shiftActivitiesAPI = {
  getAllClockings: async () => {
    return await apiRequest('/api/shift-activities/clockings');
  },
  
  getAllBreaks: async () => {
    return await apiRequest('/api/shift-activities/breaks');
  },
  
  getBreaksByClocking: async (clockingId) => {
    return await apiRequest(`/api/shift-activities/breaks/by-clocking/${clockingId}`);
  },
  
  startBreak: async (clockingId, employeeId) => {
    return await apiRequest('/api/shift-activities/breaks/start', {
      method: 'POST',
      body: JSON.stringify({ clockingId, employeeId }),
    });
  },
  
  endBreak: async (breakId) => {
    return await apiRequest(`/api/shift-activities/breaks/end/${breakId}`, {
      method: 'POST',
    });
  },
};

// Default export with all APIs
const api = {
  auth: authAPI,
  employee: employeeAPI,
  shiftActivities: shiftActivitiesAPI,
};

export default api; 